/* eslint-disable max-classes-per-file */

import { ItemMeasuresInfo } from '../ItemMeasuresInfo';
// import { CustomAttributeValue } from '../../customAttributes/customAttributeValue';
import { EvaluatedProperties } from '../../modelConfiguration/data/evaluatedProperties';
import { CatalogFileCollectionObjectVersionControl } from '../catalog/catalog';
import { FileInformation } from '../fileInformation';

export class OrderSessionData {
  customerId = '';
  customerEmailAccount = '';
  nonce = '';
}

export class CatalogOrderFileItemOption {
  groupName = '';
  groupNameTranslated = '';
  groupID = -1;
  optionName = '';
  optionNameTranslated = '';
  optionID = -1;
  price = 0;
}

export class CatalogOrderFileItemConfiguration {
  // List of options

  variantName = '';
  parts : CatalogOrderFileItemOption[] = [];
}

export class CatalogOrderFileItemCustomAttributeValue {
  attributeKey = '';
  attributeName = '';
  attributeValue = '';
  attributeTranslatedValue = '';
  attributeQuantity = 0;
  attributeHasQuantity = false;
  attributeBasePrice = 0;
  attributePriority = -1;
  attributeType = '';
  attributeEnabled = true;
}

export class CatalogOrderFileItemCustomAttributesValues {
  attributesValues : CatalogOrderFileItemCustomAttributeValue[] = [];
}

export class CatalogOrderFileItem {

  // Line Nr
  lineNr = 0;

  // Item name
  name = '';

  // Quantity
  quantity = 0;

  // Total Price = (basePrice + sum_of(configuration price) )
  totalPrice = 0.0;

  // Base Price as defined in the catalog/channel
  basePrice = 0;

  // ScreenshotId
  screenshotId = '';

  // Screenshot
  screenshotBase64? = '';

  // Configuration selected
  configuration = new CatalogOrderFileItemConfiguration();

  // Version control
  versionControl = new CatalogFileCollectionObjectVersionControl();

  // Customization properties
  customAttributesValues = new CatalogOrderFileItemCustomAttributesValues();

  // Model measures
  itemMeasures : Array<ItemMeasuresInfo> = [];

  // Model properties
  itemProperties : EvaluatedProperties = [];
}

export class CatalogOrderFileRoot {

  constructor() {
    this.fileInformation = new FileInformation('mindsales_order', 1);
    this.orderSessionData = new OrderSessionData();

    const now = new Date();
    this.creationDate = now.toISOString();
  }

  fileInformation : FileInformation;
  orderSessionData: OrderSessionData;

  // Order identifier
  orderID = '';

  channelKey = '';
  channelName = '';
  channelExternalRef = '';
  channelIsAuthenticationEnabled = false;
  channelEmail = '';
  orderExternalRef = 'None';

  catalogKey = '';
  catalogName = '';

  catalogRevision = 0;
  catalogExportKey = '';

  creationDate = '';
  language = '';

  // List of items
  items : CatalogOrderFileItem[] = [];

  // Custom attributes
  orderCustomAttributesValues : CatalogOrderFileItemCustomAttributeValue[] = [];
}
